import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    FxRateType,
} from 'app/enums/label.enums'
import {
    FxRateFields,
} from './FxRate.types'

const config: SkyNetTableConfig<FxRateFields> = {
    name: 'FxRatesTable',
    tabs: [{
        name: 'FxRates',
        url: 'all',
        fields: [
            {
                name: 'ccyFrom',
                reduced: true,
                filterType: FilterType.Array,
                filterField: 'ccyFrom',
            },
            {
                name: 'ccyTo',
                reduced: true,
                filterType: FilterType.Array,
                filterField: 'ccyTo',
            },
            {
                name: 'exchangeRate',
            },
            {
                name: 'fxRateType',
                filterField: 'fxRateType',
                fxRateType: 'array',
                componentName: 'EnumValue',
                allowedValuesEnum: FxRateType,
            },
            {
                name: 'validFrom',
                reduced: true,
                componentName: 'DateTimeCell',
            },
            {
                name: 'validTo',
                reduced: true,
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default config
